module.exports = __webpack_public_path__ + "static/media/ios-recording.c265f295.svg";